// ***** Library Imports *****
import { Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/app/(protected)/protected-route";
import EmployeeLayout from "@/app/(protected)/employee/layout";
import EmployeeHomePage from "@/app/(protected)/employee/page";
import EmployeeLeaveApplications from "@/app/(protected)/employee/leave-applications/page";
import AddLeaveApplicationOfEmployee from "@/app/(protected)/employee/leave-applications/new/page";
import EmployeeProfilePage from "@/app/(protected)/employee/profile/page";
import UploadLeadsForEmployee from "@/app/(protected)/employee/leads/upload/page";
import LeadsForEmployees from "@/app/(protected)/employee/leads/page";
import AllowancePageForEmployee from "@/app/(protected)/employee/allowance/page";
import CreateAllowancePage from "@/app/(protected)/employee/allowance/new/page";
import LoadPageOfEmployee from "@/app/(protected)/employee/loan/page";
import EmployeeIndividualLoanPage from "@/app/(protected)/employee/loan/[loanId]/page";
import EmployeeTodosPage from "@/app/(protected)/employee/todos/page";
import EmployeeAttendance from "@/app/(protected)/employee/profile/attendance/page";
import EmployeeAttendanceRequests from "@/app/(protected)/employee/profile/attendance/requests/page";
// import EmployeeSalaryCalculationPage from "@/app/(protected)/employee/profile/salary/page";
import PerformanceLogsPageForEmployee from "@/app/(protected)/employee/profile/my-performance-logs/page";
import EmployeeAnnouncements from "@/app/(protected)/employee/announcements/page";
import NotificationsPageForEmployee from "@/app/(protected)/employee/notifications/page";
import MySalaryPageForEmployee from "@/app/(protected)/employee/profile/my-salary/page";
import LeadRemindersForEmployee from "@/app/(protected)/employee/leads/(routes)/reminders/page";
import AllLeadsPageForEmployee from "@/app/(protected)/employee/leads/(routes)/all-leads/page";
import EditLeaveApplicationAsEmployee from "@/app/(protected)/employee/leave-applications/edit/page";
import SalaryTimesheet from "@/app/(protected)/employee/profile/salary-timesheet/page";
import EmployeeLeadsReportPage from "@/app/(protected)/employee/leads/(routes)/leads-report/page";
import EmployeeCompanyHolidaysPage from "@/app/(protected)/employee/company-holidays/page";

const EmployeeRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<EmployeeLayout />}>
          <Route index path="/" element={<EmployeeHomePage />} />
          <Route path="/profile" element={<EmployeeProfilePage />} />
          <Route path="/profile/attendance" element={<EmployeeAttendance />} />
          <Route
            path="/profile/attendance/requests"
            element={<EmployeeAttendanceRequests />}
          />
          {/* <Route
            path="/profile/salary"
            element={<EmployeeSalaryCalculationPage />}
          /> */}

          <Route
            path="/profile/salary-timesheet"
            element={<SalaryTimesheet />}
          />
          <Route
            path="/profile/my-salary"
            element={<MySalaryPageForEmployee />}
          />
          <Route
            path="/profile/performance-logs"
            element={<PerformanceLogsPageForEmployee />}
          />

          <Route
            path="/leave-applications"
            element={<EmployeeLeaveApplications />}
          />
          <Route
            path="/leave-applications/new"
            element={<AddLeaveApplicationOfEmployee />}
          />
          <Route
            path="/leave-applications/edit/:leaveId"
            element={<EditLeaveApplicationAsEmployee />}
          />

          <Route path="/leads" element={<LeadsForEmployees />} />
          <Route path="/leads/upload" element={<UploadLeadsForEmployee />} />
          <Route
            path="/leads/reminders"
            element={<LeadRemindersForEmployee />}
          />
          <Route
            path="/leads/all-leads"
            element={<AllLeadsPageForEmployee />}
          />
          <Route path="/leads/reports" element={<EmployeeLeadsReportPage />} />

          <Route path="/allowance" element={<AllowancePageForEmployee />} />
          <Route path="/allowance/new" element={<CreateAllowancePage />} />

          <Route path="/loan" element={<LoadPageOfEmployee />} />
          <Route
            path="/loan/:loanId"
            element={<EmployeeIndividualLoanPage />}
          />
          <Route path="/todos" element={<EmployeeTodosPage />} />

          <Route path="/announcements" element={<EmployeeAnnouncements />} />
          <Route path="/company-holidays" element={<EmployeeCompanyHolidaysPage />} />
          <Route
            path="/notifications"
            element={<NotificationsPageForEmployee />}
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default EmployeeRoutes;
